/*
 * Enter in a cart quantity field must not mean "go to checkout". KK-1293.
 *
 * Oksana, testing the neck cream ceiling on 2 September:
 *
 *   "на iPhone лимит количества работает правильно, но после этого через
 *    несколько секунд страница самостоятельно переходит к checkout, без
 *    нажатия на кнопку оформления"
 *
 * It is not the ceiling and it is not the phone. It is the cart form, and it
 * has been this way for every product since the stepper existed.
 *
 * Measured on the published theme rather than read off the markup:
 *
 *   - `CartDrawer-Form` posts to /cart and holds exactly ONE submit control,
 *     `#CartDrawer-Checkout`, `name="checkout"`. The update button beside it in
 *     the Liquid lives inside <noscript>, so with scripts on it is not an
 *     element at all and never counts.
 *   - Nothing cancels the form's submit event. Dispatching a cancelable submit
 *     on it came back uncancelled, so no theme handler is standing in the way.
 *   - The line this was measured on carried no `data-offer-max`, i.e. an
 *     ordinary cart line with no ceiling on it.
 *
 * Implicit submission does the rest, and that part is specification rather than
 * measurement: pressing Enter in a text field activates the form's default
 * button, which here is checkout, and Shopify answers a /cart post carrying
 * `checkout` by sending the shopper to checkout. On an iOS keypad the key that
 * does this is `Go` / `Done`, which is simply how a shopper puts the keyboard
 * away after typing a number.
 *
 * So the shopper types 3, reaches for the obvious key, and is taken to checkout
 * without having asked to go there.
 *
 * What this does about it: cancels that one default and blurs the field
 * instead. Blur is deliberate rather than a synthetic `change`. The browser
 * fires `change` on blur by itself when the value was edited, which is the
 * exact path the theme already handles and the exact interaction that works
 * today when the shopper clicks somewhere else. Dispatching our own `change`
 * as well would update the line twice.
 *
 * Scope is the cart's own forms and nothing else. On a product page Enter in
 * the quantity field submits the product form and adds the product, which is
 * what the shopper meant there, so that path is left alone. The gate is the
 * form's action rather than its id, so a renamed id does not silently switch
 * this off.
 *
 * This changes behaviour for every line in every cart, so it does not go live
 * on our say so. Nik decides whether Enter should keep meaning checkout.
 */
if (!window.__elanoraCartQuantityEnter) {
  window.__elanoraCartQuantityEnter = true;

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;

      /*
       * Mid composition an Enter is the IME accepting a candidate, not the
       * shopper confirming a number. Rare on a numeric field, cheap to respect.
       */
      if (event.isComposing || event.keyCode === 229) return;

      const input = event.target;
      if (!input || !input.matches) return;
      if (!input.matches('input[name="updates[]"], input.quantity__input, input[data-quantity-variant-id]')) return;

      const form = input.form;
      if (!form) return;

      const action = form.getAttribute('action') || '';
      if (!/\/cart(?:$|[?#])/.test(action)) return;

      event.preventDefault();

      /*
       * Enter still means "apply this number", it just applies it the way
       * clicking outside the field already does.
       */
      input.blur();
    },
    true
  );
}
